const sentryConfig = {
  dsn: "https://fd718325cde14ccebd0833f62e104399@o234395.ingest.sentry.io/5757378",
  tracesSampleRate: 0,
  environment: "dev",
  release: "c031acea785cd058803c35266dacdaaf4af4ed8d-Ubuntu7Standard:133e9149-69a5-452d-8fc1-486ef61dd1c1",
};

export default sentryConfig;
